import { useT } from "@/shared/i18n/useT";
import { Combobox, type ComboboxOption } from "@/shared/ui/Combobox";
import { Field, describedBy } from "@/shared/ui/Field";

interface LeadFieldProps {
  value: string | null;
  onChange: (value: string | null) => void;
  options: readonly ComboboxOption[];
  loading?: boolean;
  error?: string;
}

/** Who leads the project: an active member of staff, the creator by default. */
export function LeadField({ value, onChange, options, loading, error }: LeadFieldProps) {
  const t = useT();
  return (
    <Field id="project-lead" label={t("newProject.lead")} error={error}>
      <Combobox
        size="md"
        options={options}
        value={value}
        onChange={onChange}
        placeholder={t("newProject.leadPlaceholder")}
        searchPlaceholder={t("work.searchPeople")}
        emptyLabel={t("work.noPeopleMatch")}
        disabled={loading}
        {...describedBy("project-lead", error)}
      />
    </Field>
  );
}
